module.exports = __webpack_public_path__ + "media/images/back-4494afc5ec083a52a3cc3879ab9ee6d8.png";